import { getTicketIconSrc } from './getTicketIconSrc'

export const ticketStatuses = [
  {
    id: 2,
    name: 'Выполнен негарантийный ремонт',
    imageSrc: getTicketIconSrc(2),
  },
  {
    id: 4,
    name: 'Выполнен гарантийный ремонт',
    imageSrc: getTicketIconSrc(5),
  },
  {
    id: 5,
    name: 'Отказ в гарантийном ремонте',
    imageSrc: getTicketIconSrc(4),
  },
]
